<script setup lang="ts">
  import { computed } from 'vue'
  import { RouterView, useRoute } from 'vue-router'
  import DashboardLayout from './layouts/DashboardLayout.vue'
  import AdminLayout from './layouts/AdminLayout.vue'
  import AuthLayout from './layouts/AuthLayout.vue'
  import ClinicianLayout from './layouts/ClinicianLayout.vue'
  import MainLayout from './layouts/MainLayout.vue'

  const route = useRoute()
  const layout = computed(() => {
    switch (route.meta.layout) {
      case 'dashboard':
        return DashboardLayout
      case 'clinician':
        return ClinicianLayout
      case 'auth':
        return AuthLayout
      case 'admin':
        return AdminLayout
      case 'main':
        return MainLayout
      default:
        // Instead of defaulting, return null if meta.layout is not set
        return null
    }
  })
</script>

<template>
  <component v-if="layout" :is="layout" class="min-h-screen">
    <RouterView />
  </component>
</template>

<style scoped>
  header {
    line-height: 1.5;
    max-height: 100vh;
  }

  .logo {
    display: block;
    margin: 0 auto 2rem;
  }

  nav {
    width: 100%;
    font-size: 12px;
    text-align: center;
    margin-top: 2rem;
  }

  nav a.router-link-exact-active {
    color: var(--color-text);
  }

  nav a.router-link-exact-active:hover {
    background-color: transparent;
  }

  nav a {
    display: inline-block;
    padding: 0 1rem;
    border-left: 1px solid var(--color-border);
  }

  nav a:first-of-type {
    border: 0;
  }

  @media (min-width: 1024px) {
    header {
      display: flex;
      place-items: center;
      padding-right: calc(var(--section-gap) / 2);
    }

    .logo {
      margin: 0 2rem 0 0;
    }

    header .wrapper {
      display: flex;
      place-items: flex-start;
      flex-wrap: wrap;
    }

    nav {
      text-align: left;
      margin-left: -1rem;
      font-size: 1rem;

      padding: 1rem 0;
      margin-top: 1rem;
    }
  }
</style>
